<template>
  <section class="main">
    <van-nav-bar title="设置粉丝权益" fixed>
      <van-icon name="arrow-left" slot="left" v-back v-if="false"/>
      <van-icon name="star-o" slot="right" v-if="false"/>
    </van-nav-bar>
    <!-- <van-row class="head">
      <van-col id="shopName">女人花养生美容管</van-col>
      <van-row>
        <van-col span="18" id="shopInfo">
          <div id="phone">123456789</div>
          <div id="address">湖北省武汉市洪山区</div>
        </van-col>
        <van-col span="6" id="buttonBox">
          <router-link id="enterShop" to>进店</router-link>
        </van-col>
      </van-row>
    </van-row>
    <van-row class="notice">
      <div id="noticeBox">
        <van-col id="title">到店重置，最高享受6.5折</van-col>
        <van-col id="news">恭喜用户小明充值成功</van-col>
      </div>
    </van-row> -->
    <van-row class="addRights" v-if="list.length>0">
        <div @click="openIframe('')" class="content-add"><span id="addIcon">+</span><span>新增粉丝权益等级</span></div>
        <van-button id="del" @click="delRights">删除</van-button>
    </van-row>
    <div class="allWrapper" v-if="list.length>0">
        <van-row class="fansRights">
            <label class="title">专属权益</label>
            <div class="swipeBox" @mouseover="iconShow" @mouseout="iconHidden">
                <img src="@/assets/img/fansTeam/icon_jiantou_zuo@2x.png" id="left" v-show="rightsIcon" @click="swipeRights">
                <img src="@/assets/img/fansTeam/icon_jiantou_you@2x.png" id="right" v-show="rightsIcon" @click="swipeRights">
                <!-- <van-swipe :height="150" :show-indicators="false" @change="rightsChange" ref="rightSwipe" touchable>
                  <van-swipe-item :id="'rights_'+index" v-for="(item,index) in list" :key="item.id" :index="index" class="rights_swipe_item">
                      <div  @click="openIframe(item.id)">
                        <h3 class="ellipsis">{{item.businessName}}<span class="level">V{{index+1}}</span></h3>
                        <span class="bonus">首充即送￥{{item.interestMoney}}</span>
                      </div>
                      <span class="tip" v-if="item.referralType!=0">
                        邀请办理会员即可奖励转介绍费用{{item.referralMoney}}<span v-if="item.referralType==1">元</span><span v-if="item.referralType==2">%</span>
                      </span>
                  </van-swipe-item>
                </van-swipe> -->
                <swiper :height="150" @slideChangeTransitionEnd="rightsChange" ref="rightSwipe" class="swiper-no-swiping">
                  <swiper-slide :id="'rights_'+index" v-for="(item,index) in list" :key="item.id" :index="index" class="rights_swipe_item">
                      <div @click="openIframe(item.id)">
                        <h3 class="ellipsis">{{item.businessName}}<span class="level">V{{index+1}}</span></h3>
                        <span class="bonus">首充即送￥{{item.interestMoney}}</span>
                      </div>
                      <span class="tip" v-if="item.referralType!=0">
                        邀请办理会员即可奖励转介绍费用{{item.referralMoney}}<span v-if="item.referralType==1">元</span><span v-if="item.referralType==2">%</span>
                      </span>
                  </swiper-slide>
                </swiper>
            </div>
        </van-row>
        <van-row class="fourRights">
            <label>专属4大权益</label>
            <van-row>
              <van-col span="2" class="leftText">权</van-col>
              <van-col span="2" class="rightText">益</van-col>
              <van-col span="20">
                  <van-row>
                    <van-col span="6" class="rightsBox">
                        <img :src="iconCur<3?(iconCur<2?coin1:coin2):coin3" class="icon">
                        <span>起充金额</span>
                        <span class="amount">{{depositThreshold}}元</span>
                    </van-col>
                    <van-col span="6" class="rightsBox">
                        <img :src="iconCur<3?(iconCur<2?clock1:clock2):clock3" class="icon">
                        <span>赠送代金券</span>
                        <span class="amount">{{interestMoney}}元</span>
                    </van-col>
                    <van-col span="6" class="rightsBox">
                        <img :src="iconCur<3?(iconCur<2?coupon1:coupon2):coupon3" class="icon">
                        <span>尊享折扣</span>
                        <span class="amount">{{discount}}折</span>
                    </van-col>
                    <van-col span="6" class="rightsBox">
                        <img :src="iconCur<3?(iconCur<2?wallet1:wallet2):wallet3" class="icon">
                        <span>活动经费</span>
                        <span class="amount">{{funds}}元</span>
                    </van-col>
                  </van-row>
              </van-col>
            </van-row>
        </van-row>
        <van-row class="fansGifts" v-if="memberPresentEntity.length>0">
            <label class="title">粉丝赠品</label>
            <van-row v-for="item in memberPresentEntity" :key="item.id" class="giftsList">
                <van-col class="imgBox">
                <img :src="item.pictureUrl" class="giftsPic">
                </van-col>
                <van-col class="giftInfo">
                <span class="giftName">{{item.goodsName}}</span>
                <div class="giftAmounts">
                    <span>赠送{{item.number}}份</span>
                </div>
                <span class="giftPrice">￥{{item.price}}</span>
                </van-col>
            </van-row>
        </van-row>
        <van-row class="specialRights" v-if="memberPresentRights.length>0">
            <label class="title">特殊权益</label>
            <van-row v-for="item in memberPresentRights" :key="item.id" class="rightsList">
                <img :src="item.picUrl" class="rightsPic">
                <p class="rightsTitle">{{item.title}}</p>
            </van-row>
        </van-row>
    </div>
    <van-row class="blank" v-else>
      <img src='@/assets/img/fansTeam/img_zw@2x.png'/>
      <p>还没有粉丝可以享用的权限哦,快跟着右边导航一起设置吧~</p>
    </van-row>
  </section>
</template>

<script>
import Vue from 'vue'
import api from '@/api/ftd.js'
import mixin from '@/libs/mixin_twins'
import { Toast, Dialog } from 'vant'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

Vue.use(Toast)
Vue.use(Dialog)
export default {
  mixins: [mixin],
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      rightsIcon: false,
      cur: 0,
      iconCur: 1,
      list: [],
      giftsList: [],
      rightsList: [],
      memberPresentEntity: [],
      memberPresentRights: [],
      coin1: require('@/assets/img/fansTeam/coin1.png'),
      coin2: require('@/assets/img/fansTeam/coin2.png'),
      coin3: require('@/assets/img/fansTeam/coin3.png'),
      clock1: require('@/assets/img/fansTeam/clock1.png'),
      clock2: require('@/assets/img/fansTeam/clock2.png'),
      clock3: require('@/assets/img/fansTeam/clock3.png'),
      coupon1: require('@/assets/img/fansTeam/coupon1.png'),
      coupon2: require('@/assets/img/fansTeam/coupon2.png'),
      coupon3: require('@/assets/img/fansTeam/coupon3.png'),
      wallet1: require('@/assets/img/fansTeam/wallet1.png'),
      wallet2: require('@/assets/img/fansTeam/wallet2.png'),
      wallet3: require('@/assets/img/fansTeam/wallet3.png'),
      depositThreshold: 0,
      interestMoney: 0,
      discount: 0,
      funds: 0
    }
  },
  mounted: function() {
    let query = this.$route.query
    var params = {
      merchantId: query.merchantId
    }
    this.merchantId = query.merchantId
    if (!query.merchantId) return
    this.params = params
    this.getData(params)
  },
  methods: {
    openIframe (id) {
      parent.window.postMessage({
        target: '',
        openIframe: {
          businessId: id,
          merchantId: this.merchantId
        }
      }, '*')
    },
    iconShow() { // 显示左右切换图标
      if (this.list.length > 1) {
        this.rightsIcon = true
      }
    },
    iconHidden() { // 已隐藏左右切换图标
      this.rightsIcon = false
    },
    rightsChange() { // 切换基础权益
      var index = this.$refs.rightSwipe.swiper.activeIndex
      this.cur = index
      this.iconCur = index + 1
      this.memberPresentEntity = this.list[this.cur].memberPresentEntity
      this.memberPresentRights = this.list[this.cur].memberPresentRights
      this.openIframe(this.list[this.cur].id)
    },
    swipeRights(e) { // 切换基础权益
      var id = e.currentTarget.id
      var curChange = id == 'right' ? 1 : -1
      var curActive = this.cur + curChange
      if (curActive < this.list.length && curActive >= 0) {
        this.cur = curActive
        this.iconCur = curActive
      }
      this.memberPresentEntity = this.list[this.cur].memberPresentEntity
      this.memberPresentRights = this.list[this.cur].memberPresentRights
      this.depositThreshold = this.list[this.cur].depositThreshold
      this.interestMoney = this.list[this.cur].interestMoney
      this.discount = this.list[this.cur].discount
      this.funds = this.list[this.cur].funds
      this.$refs.rightSwipe.swiper.slideTo(this.cur)
    },
    delRights() { // 删除权益
      var _this = this
      var cur = this.cur
      var iconCur = this.iconCur
      Dialog.confirm({
        title: '提示',
        message: '确认删除吗？'
      }).then(() => {
        var delParams = {
          businessId: _this.list[_this.cur].id
        }
        api.delRights(delParams).then(function(res) {
          if (res.data.code == 1) {
            Toast('已删除')
            _this.cur = cur - 1 >= 0 ? cur - 1 : 0
            _this.iconCur = iconCur - 1 >= 1 ? iconCur - 1 : 1
            _this.$refs.rightSwipe.swiper.slideTo(_this.cur)
            _this.getData(_this.params)
          } else {
            Toast(res.data.msg)
          }
        })
      }).catch((res) => {
      })
    },
    getData(params) { // 获取数据
      Toast('加载中')
      var _this = this
      api.reqData(params).then(function(res) {
        if (res.data.code == 1) {
          var businessList = res.data.data.businessList
          for (let i = 0; i < businessList.length; i++) {
            var discount = businessList[i].discount
            var dicounts = discount > 0 ? (parseInt(discount % 10) > 0 ? discount.toString().split('').join('.') : discount.toString().split('')[0]) : 0
            businessList[i].discount = dicounts
          }
          _this.list = businessList
          if (businessList && businessList.length > 0) {
            _this.memberPresentEntity = businessList[_this.cur].memberPresentEntity
            _this.memberPresentRights = businessList[_this.cur].memberPresentRights
            _this.depositThreshold = businessList[_this.cur].depositThreshold
            _this.interestMoney = businessList[_this.cur].interestMoney
            _this.discount = businessList[_this.cur].discount
            _this.funds = businessList[_this.cur].funds
            Toast.clear()
          }
          if (_this.list.length > 0) {
            var businessId = _this.list[_this.cur].id
          }
          parent.window.postMessage({
            target: '',
            openIframe: {
              businessId: businessId,
              merchantId: _this.merchantId
            }
          }, '*')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
section {
  height: calc(100% - 46px);
  background-color: #ffffff;
  color: #333333;
  letter-spacing: 1px;
  font-size: 14px;
  padding-bottom: 0;
  overflow-y: auto;
}
.allWrapper{
    border: dashed 1px #D8AE71;
    box-sizing: border-box;
}
.head {
  padding: 23px 12px 0 12px;
  font-size: 13px;
}
.head #shopName {
  font-size: 20px;
  line-height: 52px;
  font-weight: bold;
}
.head #shopInfo {
  height: 50px;
  border-right: solid 1px #e6e6e6;
  line-height: 25px;
}
.head #phone {
  background: url('../../../assets/img/fansTeam/phone.png') 0 50% no-repeat;
  background-size: 12px 12px;
  text-indent: 19px;
}
.head #address {
  background: url("../../../assets/img/fansTeam/address.png") 0 50% no-repeat;
  background-size: 12px 14px;
  text-indent: 19px;
}
.head #enterShop {
  display: block;
  width: 55px;
  height: 25px;
  line-height: 25px;
  background-color: #f3f3f3;
  text-align: center;
  color: #7a7f9b;
  border-radius: 2px;
}
.head #buttonBox {
  display: flex;
  height: 50px;
  align-items: center;
  padding-left: 20px;
}
.notice {
  padding: 0 12px;
  margin-top: 20px;
}
.notice #noticeBox {
  height: 48px;
  line-height: 24px;
  text-indent: 60px;
  font-size: 12px;
  color: #666666;
  background: url("../../../assets/img/fansTeam/noticeBackground.png") 0 0
    no-repeat;
  background-size: 100% 100%;
  padding: 4px 0;
}
.notice #title {
  font-size: 14px;
  color: #7a7f9b;
  font-weight: bold;
}
.title {
  font-size: 20px;
  font-weight: 400;
  line-height: 60px;
}
.addRights{
    font-size: 20px;
    color: #A67227;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    position: relative;
    >.content-add{
      cursor: pointer;
      display: flex;
      align-items: center
    }
}
.addRights #addIcon{
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: solid 2px #A67227;
    text-align: center;
    line-height: 32px;
    font-size: 32px;
    margin-right: 10px;
}
.addRights #del{
    width: 80px;
    height: 30px;
    color: #ffffff;
    background-color: #D8AE71;
    position: absolute;
    right: 10px;
    bottom: 2px;
    line-height: 30px;
    border: none;
    border-radius: 4px;
}
.fansRights{
  background: -webkit-linear-gradient(
    top,
    #ffffff,
    #f0f0f0
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    bottom,
    #ffffff,
    #f0f0f0
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    bottom,
    #ffffff,
    #f0f0f0
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to bottom, #ffffff, #f0f0f0); /* 标准的语法 */
}
.fansRights .title{
    padding-left: 10px;
}
.fansRights .swipeBox {
  position: relative;
}
.swipeBox #left,.swipeBox #right{
  width: 30px;
  height: 30px;
  position: absolute;
  top: 60px;
  z-index: 999;
}
#left{
  left :10px;
}
#right{
  right: 10px;
}
.fansRights .swiper-container {
  color: #ffffff;
  font-size: 12px;
}
.fansRights h3 {
  font-size: 20px;
  color: #ffffff;
  margin: 0;
  line-height: 34px;
  font-weight: normal;
}
.fansRights .level {
  color: #7e5925;
  font-size: 18px;
  margin-left: 5px;
  font-weight: bold;
}
.fansRights .swiper-slide {
  background-size: calc(100% - 36px) 100%!important;
  background-position-x: 18px !important;
  width: calc(100% - 72px)!important;
  height: 112px;
  padding: 19px 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.fansRights  #rights_0{
  background: url("../../../assets/img/fansTeam/fansBackground1.png")
    no-repeat;
}
.fansRights #rights_1{
  background: url("../../../assets/img/fansTeam/fansBackground2.png")
    no-repeat;
}
.fansRights .rights_swipe_item:nth-child(n+3){
  background: url("../../../assets/img/fansTeam/fansBackground3.png")
    no-repeat;
}
#rights_0 .level,
#rights_0 .tip {
  color: #7e5925;
}
#rights_1 .level,
#rights_1 .tip {
  color: #444a66;
}
.rights_swipe_item:nth-child(n+3) .level,
.rights_swipe_item:nth-child(n+3) .tip {
  color: #8d5e60;
}
.fourRights {
  font-size: 12px;
  padding-top: 10px;
  margin-top: -40px;
  padding: 40px 6px 12px 6px;
  background-color: #ffffff;
  box-shadow: 0 4px 6px rgba(246, 247, 248, 1);
}
.fourRights .rightsBox {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.fourRights label {
  line-height: 40px;
  font-size: 15px;
  display: inline-block;
  width: 100%;
  text-align: center;
}
.fourRights .icon {
  width: 40px;
  height: 40px;
  margin: 10px 0;
}
.fourRights .amount {
  transform: scale(0.83);
  color: #666666;
}
.fourRights span {
  line-height: 24px;
}
.fourRights .leftText {
  text-align: right;
  border-right: dashed 1px #e6e6e6;
}
.fourRights .rightText {
  text-align: left;
}
.leftText,
.rightText {
  margin-top: 20px;
  padding-top: 5px;
  color: #999999;
  height: 60px;
  text-indent: 2px;
}
.fansGifts,.specialRights{
    padding: 0 10px;
}
.giftsList,.rightsList{
    padding: 9px 0;
}
.fansGifts .giftsPic {
  width: 90px;
  height: 90px;
  border-radius: 5px;
}
.fansGifts .giftInfo {
  display: flex;
  justify-content: space-between;
  height: 90px;
  flex-direction: column;
  width: calc(100% - 90px);
  padding-left: 20px;
}
.fansGifts .giftName{
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:2
}
.fansGifts .giftAmounts {
  font-size: 12px;
  color: #999999;
}
.fansGifts .giftPrice {
  color: #c59757;
  font-size: 18px;
}
.specialRights .rightsPic{
    width: 100%;
    height: 100px;
    border-radius: 5px;
}
.specialRights .rightsTime{
    color: #7A7F9B;
    font-size: 12px;
}
.specialRights p{
    margin: 4px 0;
}
.ellipsis{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.blank{
  text-align: center;
  padding: 120px 30px 30px 30px;
  color: #A67227;
}
.blank img{
  width: 223px;
  margin-bottom: 10px;
}
</style>
